module.exports = __webpack_public_path__ + "img/media.e5e5350f.png";